import '../Sass/App.scss';
import React, { useContext } from 'react';
import { MWContext } from '../Contexts/MWContext';

export function SpectrumItem (props) {

    const { IMAGE_ROOT } = useContext(MWContext)

    return (
        <div
            className={props.selected ? 'spectrum-item spectrum-item-selected' : 'spectrum-item'}
            style={{left: (props.codebase.complexity * 100).toString() + '%'}}
            onClick={() => props.selectCodebase(props.codebase.codebase_id)}
        >
            <img alt={props.codebase.name} src={IMAGE_ROOT + props.codebase.asset_root + 'hero-50.png'} />
        </div>
    )

}
